import { fmtChips } from "../helpers";

export function InsuranceEventsView({ events, playerByUid }) {
  if (!events?.length) return null;
  return (
    <section className="border-t border-white/10 px-3 py-3 bg-cyan-900/10" data-testid="insurance-events-view">
      <h4 className="text-[11px] uppercase tracking-wider font-semibold text-cyan-300 mb-2">
        Insurance ({events.length})
      </h4>
      <div className="space-y-2">
        {events.map((ev, idx) => (
          <div key={idx} className="text-[12px] grid grid-cols-2 gap-x-4 gap-y-1 text-slate-300">
            <span><span className="text-slate-500">Líder:</span> {ev.i_leader_nick || `uid:${ev.i_leader_uid}`}</span>
            <span><span className="text-slate-500">WPCT:</span> {ev.i_leader_wpct}%</span>
            <span><span className="text-slate-500">Buyin:</span> {fmtChips(ev.i_buyin_insurance_chips)}</span>
            <span><span className="text-slate-500">Risk pool:</span> {fmtChips(ev.i_risk_pool_chips_chips)}</span>
            <span><span className="text-slate-500">BB outs:</span> {ev.i_bb_outs}</span>
            <span><span className="text-slate-500">Buy outs:</span> {ev.i_buy_outs}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
